import React, {
  useState,
  useMemo,
  useEffect,
  useCallback
} from 'react';

// --- 1. IMPORTURI UI (ICONS) ---
import {
  Plus, X, ChefHat, ShoppingBasket, Activity, CheckCircle, Sparkles, Loader2,
  ChevronDown, BookOpen, Coffee, Utensils, Moon, Sun, Heart, Trash2, ArrowLeft,
  Printer, FileText, LogIn, LogOut, Edit3, Users, Dice5, Pencil, Check,
  AlertTriangle, Circle, Star, Globe, User, Search, ChevronLeft, ChevronRight, Share2, Shield
} from 'lucide-react';

// --- 2. IMPORTURI FIREBASE ---
import { initializeApp } from "firebase/app";
import { 
  getAuth, GoogleAuthProvider, onAuthStateChanged, 
  signInWithPopup, signInAnonymously, signOut 
} from "firebase/auth";
import {
  getFirestore, collection, doc, setDoc, deleteDoc, updateDoc, 
  onSnapshot, query, getDoc, getDocs, where,
  arrayUnion, arrayRemove, serverTimestamp
} from 'firebase/firestore';

// --- 3. CONFIGURARE FIREBASE ---
const firebaseConfig = {
  apiKey: "AIzaSyDdDYi5RyYbEhZO60lc2bxJf2gEcYMa7Wk",
  authDomain: "nutritie-app.firebaseapp.com",
  projectId: "nutritie-app",
  storageBucket: "nutritie-app.firebasestorage.app",
  messagingSenderId: "630478821860",
  appId: "1:630478821860:web:1938ca1603d24401cd8ff1"
};

// --- ADMINI APLICAȚIE ---
const ADMIN_EMAILS = [
  'voicustefan1980@gmail.com',
  'vsg1980bitcoin@gmail.com'
];

// Initializare Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  // Ignoram eroarea daca app este deja initializat
}

const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Cheia pentru Google Gemini AI
const apiKey = 'AIzaSyC767WokDoqiOCpDZx_hZYD5YNNa1oiyq4';

// --- UTILS NAVIGARE SIGURA ---
const safeUpdateURL = (url) => {
  try {
    window.history.pushState({ path: url }, '', url);
  } catch (e) {
    console.warn("URL update blocked by environment (safe to ignore in preview).");
  }
};

// --- 4. DATE DEMO & FALLBACK ---
const RECIPES_DB = [
  {
    id: 'demo-1',
    title: 'Omletă cu Spanac și Feta',
    category: 'Mic Dejun',
    time: '15 min',
    calories: '320 kcal',
    carbs: '4g',
    servings: 1,
    image: '🍳',
    ingredients: ['2 oua', '50g spanac', '30g branza feta', '1 lingurita ulei de masline', 'sare', 'piper'],
    instructions: ['Bate ouăle într-un bol cu sare și piper.', 'Sotează spanacul în ulei timp de 2 minute.', 'Adaugă ouăle bătute peste spanac.', 'Când omleta este aproape gata, presară brânza feta sfărâmată.', 'Împăturește și servește cald.'],
    isDiabeticFriendly: true,
    votes: 5
  },
  {
    id: 'demo-2',
    title: 'Salată de Ton cu Avocado',
    category: 'Prânz',
    time: '10 min',
    calories: '450 kcal',
    carbs: '8g',
    servings: 1,
    image: '🥗',
    ingredients: ['1 conserva ton', '1 avocado', '1 ceapa rosie mica', 'jumatate lamaie', 'patrunjel', 'sare'],
    instructions: ['Scurge tonul de lichid.', 'Taie avocado cubulețe și ceapa mărunt.', 'Amestecă toate ingredientele într-un bol.', 'Asezonează cu zeamă de lămâie, sare și pătrunjel proaspăt.'],
    isDiabeticFriendly: true,
    votes: 12
  },
  {
    id: 'demo-3',
    title: 'Pui cu Ciuperci și Smântână',
    category: 'Cină',
    time: '30 min',
    calories: '550 kcal',
    carbs: '6g',
    servings: 2,
    image: '🥘',
    ingredients: ['300g piept de pui', '200g ciuperci', '100ml smantana', '2 catei usturoi', 'unt', 'marar'],
    instructions: ['Taie puiul cubulețe și prăjește-l în unt până se rumenește.', 'Scoate puiul și în aceeași tigaie călește ciupercile feliate.', 'Adaugă usturoiul pisat și puiul înapoi în tigaie.', 'Toarnă smântâna lichidă și lasă să scadă sosul 5 minute.', 'Presară mărar proaspăt la final.'],
    isDiabeticFriendly: true,
    votes: 8
  }
];

// --- 5. CONSTANTE & UTILS ---
const INGREDIENT_CATEGORIES = {
  Carne: ['pui', 'bacon', 'carne', 'oua', 'jambon', 'vita', 'porc', 'carnati', 'miel', 'curcan', 'sunca', 'salam'],
  Pește: ['peste', 'ton', 'somon', 'cod', 'macrou', 'sardine', 'dorada', 'pastrav', 'creveti', 'fructe de mare', 'calamar'],
  'Lactate & Brânzeturi': ['lapte', 'branza', 'parmezan', 'smantana', 'iaurt', 'unt', 'cascaval', 'kefir', 'mascarpone', 'mozzarella', 'ghee', 'feta'],
  Fructe: ['mar', 'mere', 'banana', 'banane', 'capsuni', 'zmeura', 'afine', 'mure', 'avocado', 'lamaie', 'portocala', 'pepene', 'struguri', 'kivi', 'pere', 'piersici'],
  'Legume & Zarzavaturi': ['cartofi', 'ceapa', 'ardei', 'spanac', 'sparanghel', 'rosii', 'castraveti', 'masline', 'fasole verde', 'usturoi', 'mazare verde', 'mazare pastai', 'mazare', 'morcovi', 'telina', 'conopida', 'brocoli', 'salata', 'varza', 'ciuperci', 'vinete', 'nopal', 'rucola', 'patrunjel', 'marar', 'menta', 'busuioc'],
  'Leguminoase & Boabe': ['mazare', 'mazare boabe', 'fasole', 'fasole boabe', 'naut', 'linte', 'bob', 'soia'],
  'Făinoase & Nuci': ['faina', 'orez', 'paste', 'paine', 'migdale', 'nuci', 'chia', 'seminte', 'psyllium', 'in'],
  'Condimente & Altele': ['ulei', 'sare', 'piper', 'zahar', 'otet', 'mustar', 'mayo', 'sos', 'cacao', 'vanilie', 'indulcitor', 'praf de copt', 'bicarbonat', 'scortisoara', 'curry', 'boia', 'chimen', 'tahini', 'tajin']
};

const CATEGORY_STYLES = {
  Carne: { color: 'text-rose-300', bg: 'bg-rose-900/30', border: 'border-rose-800', icon: '🥩' },
  Pește: { color: 'text-cyan-300', bg: 'bg-cyan-900/30', border: 'border-cyan-800', icon: '🐟' },
  Fructe: { color: 'text-orange-300', bg: 'bg-orange-900/30', border: 'border-orange-800', icon: '🍎' },
  'Lactate & Brânzeturi': { color: 'text-sky-300', bg: 'bg-sky-900/30', border: 'border-sky-800', icon: '🧀' },
  'Legume & Zarzavaturi': { color: 'text-emerald-300', bg: 'bg-emerald-900/30', border: 'border-emerald-800', icon: '🥕' },
  'Leguminoase & Boabe': { color: 'text-lime-300', bg: 'bg-lime-900/30', border: 'border-lime-800', icon: '🫘' },
  'Făinoase & Nuci': { color: 'text-amber-300', bg: 'bg-amber-900/30', border: 'border-amber-800', icon: '🍞' },
  'Condimente & Altele': { color: 'text-slate-300', bg: 'bg-slate-800', border: 'border-slate-700', icon: '🧂' },
  Altele: { color: 'text-gray-300', bg: 'bg-gray-800', border: 'border-gray-700', icon: '📦' }
};

const COOKBOOK_CATEGORIES = [
  { id: 'Toate', icon: <BookOpen size={14} /> },
  { id: 'Mic Dejun', icon: <Coffee size={14} /> },
  { id: 'Prânz', icon: <Utensils size={14} /> },
  { id: 'Cină', icon: <Moon size={14} /> },
  { id: 'Desert', icon: <Sun size={14} /> },
  { id: 'Băuturi', icon: <Utensils size={14} /> },
  { id: 'Garnituri', icon: <Utensils size={14} /> },
  { id: 'Sosuri', icon: <Utensils size={14} /> }
];

const removeDiacritics = (str) => {
  if (typeof str !== 'string') return '';
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};

const getCategoryForIngredient = (ingredient) => {
  const normalizedInput = removeDiacritics(ingredient);
  for (const [category, items] of Object.entries(INGREDIENT_CATEGORIES)) {
    if (items.some((item) => normalizedInput.includes(item))) {
      return category;
    }
  }
  return 'Altele';
};

const safeRender = (content, fallback = '') => {
  if (content === null || content === undefined) return fallback;
  if (typeof content === 'string' || typeof content === 'number') return content;
  if (React.isValidElement(content)) return content;
  if (typeof content === 'object') return '';
  return fallback;
};

// --- DATE UTILS pentru publicare ---
const getDateFromField = (value) => {
  if (!value) return null;
  try {
    if (value.toDate && typeof value.toDate === 'function') {
      const d = value.toDate();
      if (!isNaN(d)) return d;
    }
  } catch (_) {}
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    const d = new Date(value.seconds * 1000);
    if (!isNaN(d)) return d;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    if (!isNaN(d)) return d;
  }
  return null;
};

const formatDateTime = (value) => {
  const d = getDateFromField(value);
  if (!d) return '';
  return new Intl.DateTimeFormat('ro-RO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d);
};

// --- 6. COMPONENTE MICI (UI) ---

const AppLogo = ({ size = 34 }) => {
  return (
    <div className="flex items-center gap-2 select-none">
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-md">
        <defs>
          <linearGradient id="ns-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="50%" stopColor="#0ea5e9" />
            <stop offset="100%" stopColor="#6366f1" />
          </linearGradient>
        </defs>
        <rect x="4" y="4" width="56" height="56" rx="18" fill="url(#ns-grad)" />
        <path d="M32 16C25 22 22 27.5 22 32.5C22 39 26.5 44 32 44C37.5 44 42 39 42 32.5C42 27.5 39 22 32 16Z" fill="white" fillOpacity="0.95" />
        <path d="M32 22L32 38" stroke="#16a34a" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M28 30L30 32M36 30L34 32" stroke="#22c55e" strokeWidth="1.6" strokeLinecap="round" />
        <text x="11" y="52" fontFamily="system-ui" fontSize="10" fill="rgba(255,255,255,0.9)" fontWeight="700">NS</text>
      </svg>
      <div className="leading-tight text-white">
        <div className="text-sm sm:text-base font-semibold tracking-tight">
          <span>Nutritie</span><span className="font-extrabold">Smart</span>
        </div>
        <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-blue-100/80">
          Low Carb • DZ2
        </div>
      </div>
    </div>
  );
};

const RecipeSEO = ({ recipe }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Recipe",
    "name": recipe.title,
    "image": ["https://images.unsplash.com/photo-1495521821757-a1efb6729352?q=80&w=1000&auto=format&fit=crop"],
    "author": { "@type": "Person", "name": recipe.authorName || "NutritieSmart AI" },
    "datePublished": recipe.publishedAt ? (getDateFromField(recipe.publishedAt)?.toISOString() || new Date().toISOString()) : new Date().toISOString(),
    "description": `O rețetă delicioasă de ${recipe.title}.`,
    "prepTime": "PT10M",
    "cookTime": "PT20M",
    "totalTime": "PT30M",
    "recipeCategory": recipe.category,
    "nutrition": { "@type": "NutritionInformation", "calories": recipe.calories || "300 calories" },
    "recipeIngredient": recipe.ingredients || [],
    "recipeInstructions": (recipe.instructions || []).map(step => ({ "@type": "HowToStep", "text": step }))
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
};

const DraggableIngredient = ({ name, category, onDelete, isSelected, onToggle }) => {
  return (
    <div 
      onClick={() => onToggle(name)} 
      className={`relative select-none transition-all duration-200 flex items-center justify-between gap-1 px-2 py-1.5 rounded-lg border cursor-pointer ${
        isSelected
          ? 'bg-slate-700 border-green-500 shadow-sm'
          : 'bg-slate-800 border-transparent hover:bg-slate-700/80'
      }`}
    >
      <button 
        onClick={(e) => { e.stopPropagation(); onDelete(name); }} 
        className="p-1 text-red-400 hover:text-red-600 hover:bg-red-100 rounded-full transition-colors flex-shrink-0"
      >
        <X size={14} />
      </button>
      <span className={`flex-1 text-center text-xs font-bold truncate mx-1 ${
        isSelected ? 'text-white' : 'text-slate-300'
      }`}>
        {safeRender(name)}
      </span>
      <div className="flex-shrink-0">
        {isSelected ? (
          <CheckCircle size={18} className="text-green-400 fill-green-900/30" />
        ) : (
          <Circle size={18} className="text-slate-500" />
        )}
      </div>
    </div>
  );
};

const PrintPreviewScreen = ({ recipe, onClose }) => {
  const handlePrint = () => { window.print(); };
  if (!recipe) return null;
  return (
    <div className="fixed inset-0 bg-slate-900 z-[9999] flex flex-col items-center justify-start overflow-auto p-4 sm:p-8">
      <div className="w-full max-w-3xl flex justify-between items-center mb-6 print:hidden">
        <button onClick={onClose} className="flex items-center gap-2 text-slate-300 hover:text-white transition">
          <ArrowLeft size={20} /> Înapoi
        </button>
        <button onClick={handlePrint} className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-xl font-bold shadow-lg transition">
          <Printer size={20} /> Printează / PDF
        </button>
      </div>
      <div className="bg-white text-black w-full max-w-[210mm] min-h-[297mm] p-[20mm] shadow-2xl rounded-sm print:shadow-none print:w-full print:max-w-none print:min-h-0 print:p-0 print:m-0">
        <div className="text-center border-b-2 border-gray-200 pb-6 mb-8">
          <div className="flex justify-center items-center gap-2 mb-2 text-gray-400 text-xs uppercase tracking-widest">
            <ChefHat size={14} /> NutritieSmart
          </div>
          <h1 className="text-3xl sm:text-4xl font-serif font-bold text-gray-900 mb-4">
            {safeRender(recipe.title)}
          </h1>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-sm font-medium text-gray-600">
            <span className="flex items-center gap-1">⏱ {safeRender(recipe.time)}</span>
            {recipe.calories && <span className="flex items-center gap-1">🔥 {safeRender(recipe.calories)}</span>}
            <span className="flex items-center gap-1">🍞 {safeRender(recipe.carbs || 'Low Carb')}</span>
            <span className="flex items-center gap-1">🍽️ {safeRender(recipe.servings || 2)} Porții</span>
          </div>
        </div>
        <div className="mb-8">
          <h3 className="text-lg font-bold uppercase tracking-wider text-gray-800 mb-4 border-b border-gray-100 pb-2">
            Ingrediente
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-sm text-gray-700">
            {Array.isArray(recipe.ingredients) && recipe.ingredients.map((ing, i) => (
              <div key={i} className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                <span className="leading-relaxed">{safeRender(ing)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="mb-8">
          <h3 className="text-lg font-bold uppercase tracking-wider text-gray-800 mb-4 border-b border-gray-100 pb-2">
            Mod de Preparare
          </h3>
          <div className="space-y-4 text-sm text-gray-700 leading-relaxed">
            {Array.isArray(recipe.instructions) && recipe.instructions.map((step, i) => (
              <div key={i} className="flex gap-4">
                <span className="font-bold text-gray-400 w-6 flex-shrink-0 text-right">
                  {i + 1}.
                </span>
                <p>{safeRender(step)}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-gray-100 text-center text-xs text-gray-400">
          Generat automat de aplicația NutritieSmart.
        </div>
      </div>
    </div>
  );
};

// --- 7. COMPONENTE MARI (SECTIUNI) ---

// TAB: ADMIN
const AdminPanel = ({ recipes, onAdminDelete }) => {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('all'); // all | community | official
  const [sortBy, setSortBy] = useState('date'); // 'date' | 'votes'

  const filtered = useMemo(() => {
    const normalizedSearch = removeDiacritics(search);

    return (recipes || [])
      .filter((r) => {
        if (!normalizedSearch) return true;
        const titleNormalized = removeDiacritics(r.title || '');
        return titleNormalized.includes(normalizedSearch);
      })
      .filter((r) => {
        if (typeFilter === 'community') return r.type === 'community';
        if (typeFilter === 'official') return r.type !== 'community';
        return true;
      })
      .sort((a, b) => {
        if (sortBy === 'votes') {
          return (b.votes || 0) - (a.votes || 0);
        }
        const da = getDateFromField(a.publishedAt);
        const db = getDateFromField(b.publishedAt);
        if (!da && !db) return 0;
        if (!da) return 1;
        if (!db) return -1;
        return db.getTime() - da.getTime();
      });
  }, [recipes, search, typeFilter, sortBy]);

  return (
    <div className="space-y-4 animate-fade-in">
      <div className="flex flex-col sm:flex-row justify-between gap-3 items-center">
        <h2 className="text-lg font-bold text-slate-100 flex items-center gap-2">
          <Shield size={18} className="text-amber-500"/> Panou Admin – Rețete
        </h2>
        <div className="flex gap-2 flex-wrap">
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="border border-slate-700 bg-slate-800 rounded-xl px-2 py-1.5 text-xs text-slate-200"
          >
            <option value="all">Toate</option>
            <option value="official">Oficiale</option>
            <option value="community">Comunitate</option>
          </select>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="border border-slate-700 bg-slate-800 rounded-xl px-2 py-1.5 text-xs text-slate-200"
          >
            <option value="date">Sortare: Dată (nou → vechi)</option>
            <option value="votes">Sortare: Voturi</option>
          </select>
        </div>
      </div>

      <div className="relative">
        <Search
          className="absolute left-3 top-2.5 text-slate-400"
          size={16}
        />
        <input
          type="text"
          placeholder="Caută după titlul rețetei (cu sau fără diacritice)..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-9 pr-3 py-2.5 rounded-xl border border-slate-700 bg-slate-800 text-sm text-slate-100 focus:ring-2 focus:ring-indigo-500 outline-none"
        />
      </div>

      <div className="border border-slate-700 rounded-2xl overflow-hidden bg-slate-900/40">
        <div className="grid grid-cols-12 text-[11px] font-bold uppercase tracking-wide text-slate-400 bg-slate-800/80 px-3 py-2">
          <div className="col-span-4">Titlu</div>
          <div className="col-span-2">Tip</div>
          <div className="col-span-2">Dată</div>
          <div className="col-span-2 text-center">Voturi</div>
          <div className="col-span-1">ID</div>
          <div className="col-span-1 text-center">Șterge</div>
        </div>
        {filtered.length === 0 && (
          <div className="text-center text-xs text-slate-400 py-6">
            Nicio rețetă găsită.
          </div>
        )}
        {filtered.map((r) => {
          const shareKey = r.shareId || r.id;
          const linkHref = `${window.location.origin}${window.location.pathname}?reteta=${shareKey}`;
          return (
            <div
              key={r.id}
              className="grid grid-cols-12 items-center text-[11px] border-t border-slate-800 px-3 py-2 hover:bg-slate-800/50"
            >
              <div className="col-span-4 font-semibold text-slate-100 truncate">
                <a
                  href={linkHref}
                  className="text-sky-300 hover:underline"
                  target="_blank"
                  rel="noreferrer"
                  title="Deschide rețeta în noul tab"
                >
                  {safeRender(r.title)}
                </a>
              </div>
              <div className="col-span-2">
                {r.type === 'community' ? (
                  <span className="px-2 py-0.5 rounded-full bg-green-900/40 text-[10px] text-green-300 font-bold">
                    Comunitate
                  </span>
                ) : (
                  <span className="px-2 py-0.5 rounded-full bg-blue-900/40 text-[10px] text-blue-300 font-bold">
                    Oficial
                  </span>
                )}
              </div>
              <div className="col-span-2 text-[10px] text-slate-400">
                {formatDateTime(r.publishedAt) || '-'}
              </div>
              <div className="col-span-2 text-center text-slate-200">
                ⭐ {r.votes || 0}
              </div>
              <div className="col-span-1 text-[10px] text-slate-400 truncate">
                {r.id}
              </div>
              <div className="col-span-1 flex justify-center">
                <button
                  onClick={() => onAdminDelete(r)}
                  className="p-1.5 rounded-full bg-red-900/40 text-red-300 hover:bg-red-800 transition"
                  title="Șterge din Firestore"
                >
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-[11px] text-slate-500">
        * Ștergerea se face direct din colecția <code>recipes</code> din Firestore. Ai grijă ce ștergi! 🙂
      </p>
    </div>
  );
};

// TAB: CAMARA
const PantryTab = ({
  groupedIngredients,
  selectedCategory,
  setSelectedCategory,
  inputValue,
  setInputValue,
  onAdd,
  onToggle,
  onDelete,
  activeIngredients,
  onGenerateAi,
  isGenerating,
  aiError,
  extraInst,
  setExtraInst,
  servings,
  setServings,
  onRandomAi,
  onInputChange,
  isAnonymous,
  handleLogin
}) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-gradient-to-br from-indigo-600 to-purple-700 text-white p-5 rounded-2xl shadow-lg relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="text-xl font-bold mb-2 flex items-center gap-2">
            <ChefHat className="text-yellow-300" /> Bun venit la NutrițieSmart!
          </h2>
          <p className="text-indigo-100 text-sm mb-3 max-w-xl leading-relaxed">
            Nu știi ce să gătești? Adaugă ingredientele pe care le ai în frigider, iar Chef AI îți va genera rețete delicioase și sănătoase instant!
          </p>
          {isAnonymous && (
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-3 rounded-xl flex flex-col sm:flex-row items-start gap-3 mt-4">
              <AlertTriangle className="text-yellow-300 shrink-0 mt-0.5" size={20} />
              <div className="flex-1">
                <strong className="block text-yellow-300 text-sm mb-1">
                  Ești în modul Vizitator Temporar
                </strong>
                <p className="text-xs text-indigo-50 mb-2">
                  Rețetele și ingredientele tale nu se vor salva permanent. Conectează-te pentru a avea acces la ele oricând.
                </p>
                <button
                  onClick={handleLogin}
                  className="bg-white text-indigo-700 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-indigo-50 transition shadow-sm inline-flex items-center gap-1"
                >
                  <LogIn size={12} /> Conectare cu Google
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-purple-500/20 rounded-full blur-xl"></div>
      </div>

      <div className="bg-slate-800 rounded-2xl shadow-sm border border-slate-700 transition-colors">
        <div className="p-4 border-b border-slate-700 bg-slate-800/50">
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="relative sm:w-40">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full border border-slate-600 rounded-xl pl-2 pr-6 py-2.5 text-sm bg-slate-700 text-slate-100 outline-none appearance-none cursor-pointer transition-colors shadow-sm"
              >
                <option value="Altele">Altele</option>
                {Object.keys(INGREDIENT_CATEGORIES).map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <ChevronDown
                size={14}
                className="absolute right-2 top-3.5 text-slate-400 pointer-events-none"
              />
            </div>
            <div className="flex flex-1 gap-2">
              <input
                type="text"
                value={inputValue}
                onChange={onInputChange}
                onKeyDown={(e) => e.key === 'Enter' && onAdd()}
                placeholder="Adaugă produs (ex: ouă, roșii)..."
                className="flex-1 border border-slate-600 rounded-xl px-3 py-2.5 text-sm bg-slate-700 text-white outline-none focus:ring-2 focus:ring-indigo-500 transition-colors placeholder-slate-400 shadow-sm"
              />
              <button
                onClick={onAdd}
                className="bg-indigo-600 text-white px-4 rounded-xl hover:bg-indigo-700 transition shadow-md active:scale-95 transform"
              >
                <Plus />
              </button>
            </div>
          </div>
        </div>
        <div className="p-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
          {Object.entries(groupedIngredients).map(([cat, items]) => {
            const st = CATEGORY_STYLES[cat] || CATEGORY_STYLES.Altele;
            return (
              <div
                key={cat}
                className={`${st.bg} ${st.border} border rounded-xl p-2 flex flex-col h-48 transition-colors`}
              >
                <h4
                  className={`text-[10px] font-bold uppercase ${st.color} mb-2 pb-1 border-b ${st.border} truncate flex items-center gap-1.5`}
                >
                  <span className="text-base">{st.icon}</span>{' '}
                  <span className="truncate">{cat}</span>
                </h4>
                <div className="flex-1 overflow-y-auto custom-scrollbar space-y-1 pr-1">
                  {items.length === 0 ? (
                    <div className="text-xs italic text-center py-4 text-slate-500">
                      Gol
                    </div>
                  ) : (
                    items.map((ing) => (
                      <DraggableIngredient
                        key={ing.name}
                        name={ing.name}
                        category={cat}
                        isSelected={ing.isSelected}
                        onToggle={onToggle}
                        onDelete={onDelete}
                      />
                    ))
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="bg-indigo-900/20 border border-indigo-800 rounded-2xl p-6 text-center relative overflow-hidden group transition-colors">
        <div className="relative z-10">
          <h3 className="font-bold text-indigo-200 flex justify-center items-center gap-2 mb-4 text-lg">
            <Sparkles className="text-indigo-500 fill-indigo-200" /> Chef AI
          </h3>
          <div className="max-w-md mx-auto space-y-4">
            {activeIngredients.length > 0 ? (
              <div className="bg-slate-800/60 p-3 rounded-xl border border-indigo-800/50">
                <span className="text-xs font-bold text-indigo-200 block mb-2 text-left">
                  Ingrediente selectate ({activeIngredients.length}):
                </span>
                <div className="flex flex-wrap gap-2 max-h-24 overflow-y-auto custom-scrollbar">
                  {activeIngredients.map((ing) => (
                    <span
                      key={ing.name}
                      className="bg-slate-700 border border-green-800 text-slate-100 text-xs px-2 py-1 rounded-md shadow-sm flex items-center gap-1"
                    >
                      <CheckCircle size={10} className="text-green-500" />{' '}
                      {ing.name}
                    </span>
                  ))}
                </div>
              </div>
            ) : (
              <div className="bg-indigo-900/50 p-3 rounded-xl border border-dashed border-indigo-700 text-xs text-indigo-100">
                Selectează ingrediente din cămară pentru a genera o rețetă.
              </div>
            )}
            <div className="text-left grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="text-xs font-bold text-indigo-100 ml-1 mb-1 block flex items-center gap-1">
                  <Users size={12} /> Număr de porții
                </label>
                <div className="flex items-center shadow-sm">
                  <button
                    onClick={() => setServings(Math.max(1, servings - 1))}
                    className="bg-slate-800 border border-indigo-700 rounded-l-xl px-3 py-2 text-indigo-300 hover:bg-indigo-900/30"
                  >
                    -
                  </button>
                  <div className="flex-1 bg-slate-800/80 border-t border-b border-indigo-700 py-2 text-center font-bold text-white text-sm">
                    {servings} {servings === 1 ? 'Porție' : 'Porții'}
                  </div>
                  <button
                    onClick={() => setServings(servings + 1)}
                    className="bg-slate-800 border border-indigo-700 rounded-r-xl px-3 py-2 text-indigo-300 hover:bg-indigo-900/30"
                  >
                    +
                  </button>
                </div>
              </div>
              <div>
                <label className="text-xs font-bold text-indigo-100 ml-1 mb-1 block flex items-center gap-1">
                  <Edit3 size={10} /> Preferințe (Opțional)
                </label>
                <textarea
                  value={extraInst}
                  onChange={(e) => setExtraInst(e.target.value)}
                  placeholder="Ex: fără sare, picant..."
                  className="w-full border border-indigo-700 rounded-xl px-3 py-2 text-sm bg-slate-800/80 text-white outline-none focus:ring-2 focus:ring-indigo-500 transition-colors resize-none h-[42px] placeholder-indigo-400 shadow-sm"
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <button
                onClick={() => onGenerateAi(null)}
                disabled={isGenerating || activeIngredients.length === 0}
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 transition text-white px-4 py-3 rounded-xl text-sm font-bold shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transform active:scale-95"
              >
                {isGenerating ? (
                  <Loader2 className="animate-spin" size={16} />
                ) : (
                  <>
                    <Sparkles size={16} /> Generează Rețeta
                  </>
                )}
              </button>
              <button
                onClick={onRandomAi}
                disabled={isGenerating}
                className="flex-1 bg-purple-600 hover:bg-purple-700 transition text-white px-4 py-3 rounded-xl text-sm font-bold shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transform active:scale-95"
              >
                <Dice5 size={18} /> Aleatoriu
              </button>
            </div>
          </div>
          {aiError && (
            <p className="text-red-500 text-xs mt-2 font-bold bg-red-900/20 py-1 px-2 rounded inline-block border border-red-800">
              {aiError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

// COMPONENTA VIZUALIZARE RETETA
const RecipeView = ({
  recipe,
  onBack,
  onSave,
  onUpdate,
  onDelete,
  isSaved,
  isSaving,
  onPrint,
  onVote,
  user,
  onPublish,
  isPublished
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [edited, setEdited] = useState(recipe);
  const hasVoted = useMemo(
    () => recipe.votedBy && user && recipe.votedBy.includes(user.uid),
    [recipe.votedBy, user]
  );

  useEffect(() => {
    setEdited(recipe);
    setIsEditing(false);
  }, [recipe]);

  const handleSaveEdit = () => {
    onUpdate(edited);
    setIsEditing(false);
  };
  const handleChange = (field, val) =>
    setEdited({ ...edited, [field]: val });
  const handleListChange = (field, val) =>
    setEdited({
      ...edited,
      [field]: val.split('\n').filter((l) => l.trim())
    });

  const copyLink = () => {
    const shareKey = recipe.shareId || recipe.id;
    const url = `${window.location.origin}${window.location.pathname}?reteta=${shareKey}`;
    const textField = document.createElement('textarea');
    textField.innerText = url;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    alert('Link copiat! 🔗');
  };

  const isCommunity = recipe.type === 'community';

  const formattedDate = formatDateTime(recipe.publishedAt);

  if (!recipe) return null;

  return (
    <div className="bg-slate-800 rounded-2xl shadow-lg border border-slate-700 overflow-hidden animate-fade-in pb-8">
      <RecipeSEO recipe={recipe} />

      <div
        className={`p-6 text-center relative ${
          recipe.isAiGenerated
            ? 'bg-indigo-900/20'
            : 'bg-blue-900/20'
        }`}
      >
        <div className="text-6xl mb-4">
          {safeRender(recipe.image)}
        </div>
        {isEditing ? (
          <input
            type="text"
            value={edited.title}
            onChange={(e) => handleChange('title', e.target.value)}
            className="w-full text-2xl font-bold text-center bg-slate-700/50 border border-blue-200 rounded-lg p-2 mb-2 text-white"
          />
        ) : (
          <h2 className="text-2xl font-bold text-white px-4 leading-tight">
            {safeRender(recipe.title)}
          </h2>
        )}

        {recipe.isAiGenerated && !isCommunity && (
          <div className="absolute top-4 left-4 flex gap-2">
            {isEditing ? (
              <button
                onClick={handleSaveEdit}
                className="p-2 bg-green-500 text-white rounded-full shadow-md hover:bg-green-600 transition"
              >
                <Check size={16} />
              </button>
            ) : (
              <button
                onClick={() => setIsEditing(true)}
                className="p-2 bg-slate-700 text-slate-300 rounded-full shadow-md border border-slate-600 transition"
              >
                <Pencil size={16} />
              </button>
            )}
            <button
              onClick={() => onDelete(recipe.id)}
              className="p-2 bg-slate-700 text-red-500 rounded-full shadow-md border border-slate-600 transition"
            >
              <Trash2 size={16} />
            </button>
          </div>
        )}

        {recipe.isAiGenerated && !recipe.type && (
          <div className="absolute top-4 right-4 bg-indigo-800 text-indigo-200 text-[10px] px-2 py-1 rounded-full font-bold shadow-sm">
            AI
          </div>
        )}
        {recipe.type === 'community' && (
          <div className="absolute top-4 right-4 bg-green-800 text-green-200 text-[10px] px-2 py-1 rounded-full font-bold shadow-sm flex items-center gap-1">
            <Globe size={10} /> Comunitate
          </div>
        )}

        <div className="flex justify-center gap-3 mt-4 text-xs font-bold flex-wrap">
          {['time', 'calories', 'carbs', 'servings'].map((f) =>
            isEditing ? (
              <input
                key={f}
                className="w-20 p-1 rounded border text-center dark:bg-slate-700 dark:text-white"
                placeholder={f}
                value={edited[f] || ''}
                onChange={(e) => handleChange(f, e.target.value)}
              />
            ) : (
              recipe[f] && (
                <span
                  key={f}
                  className="bg-slate-700 px-3 py-1 rounded-lg border border-slate-600 text-slate-200 shadow-sm"
                >
                  {f === 'servings'
                    ? `${safeRender(recipe[f])} Porții`
                    : safeRender(recipe[f])}
                </span>
              )
            )
          )}
        </div>
      </div>

      {!isEditing && (
        <div className="px-6 mt-2 mb-2">
          {(recipe.authorName || formattedDate) && (
            <div className="mb-3 text-[11px] text-center text-slate-400 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2">
              {recipe.authorName && (
                <span className="flex items-center gap-1">
                  <User size={12} /> Publicat de:{' '}
                  <span className="font-bold">
                    {safeRender(recipe.authorName)}
                  </span>
                </span>
              )}
              {formattedDate && (
                <span className="text-slate-500">
                  • {formattedDate}
                </span>
              )}
            </div>
          )}
        </div>
      )}

      {!isEditing && (
        <div className="px-6 -mt-1 relative z-10 flex justify-center flex-wrap gap-3">
          {(!recipe.isAiGenerated || recipe.type === 'community') && (
            <button
              onClick={() => onVote(recipe)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 text-sm ${
                hasVoted
                  ? 'bg-yellow-400 text-yellow-900 border border-yellow-500 ring-2 ring-yellow-200 dark:ring-yellow-900'
                  : 'bg-slate-700 text-slate-200 hover:bg-slate-600 border border-slate-600'
              }`}
            >
              {hasVoted ? (
                <Star className="fill-yellow-900" size={16} />
              ) : (
                <Star size={16} />
              )}
              {hasVoted ? 'Votat!' : 'Îmi place?'}{' '}
              <span className="bg-black/10 px-1.5 rounded text-xs">
                {recipe.votes || 0}
              </span>
            </button>
          )}

          {isSaved &&
            recipe.isAiGenerated &&
            !isCommunity && (
              <button
                onClick={() => onPublish(recipe)}
                className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 text-sm bg-green-600 text-white hover:bg-green-700"
              >
                <Globe size={16} /> {recipe.communityId ? 'Actualizează în Comunitate 🔄' : 'Publică în Comunitate 🌍'}
              </button>
            )}

          {recipe.isAiGenerated && !isSaved && !isCommunity && (
            <button
              onClick={() => onSave(recipe)}
              disabled={isSaving}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 text-sm bg-slate-700 text-indigo-300 hover:bg-slate-600 border border-indigo-600"
            >
              {isSaving ? (
                <Loader2 className="animate-spin" size={16} />
              ) : (
                <Heart size={16} />
              )}{' '}
              Salvează
            </button>
          )}

          <button
            onClick={copyLink}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 text-sm bg-slate-700 text-slate-200 hover:bg-slate-600 border border-slate-600"
          >
            <Share2 size={16} /> Share
          </button>
          <button
            onClick={onPrint}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-bold shadow-lg transition transform active:scale-95 text-sm bg-slate-700 text-slate-200 hover:bg-slate-600 border border-slate-600"
          >
            <FileText size={16} /> PDF / Print
          </button>
        </div>
      )}
      <div className="p-6 pt-4">
        <h3 className="font-bold text-slate-200 mb-3 flex items-center gap-2 text-lg border-b border-slate-700 pb-2">
          <ShoppingBasket size={20} className="text-blue-500" /> Ingrediente
        </h3>
        {isEditing ? (
          <textarea
            value={
              Array.isArray(edited.ingredients)
                ? edited.ingredients.join('\n')
                : ''
            }
            onChange={(e) =>
              handleListChange('ingredients', e.target.value)
            }
            className="w-full h-40 p-3 text-sm border rounded-xl dark:bg-slate-700 dark:text-white dark:border-slate-600 focus:ring-2 focus:ring-blue-500"
          />
        ) : (
          <ul className="space-y-2 mb-8 text-sm text-slate-300">
            {Array.isArray(recipe.ingredients) &&
              recipe.ingredients.map((ing, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 p-2 rounded-lg hover:bg-slate-700/30 transition"
                >
                  <div className="w-1.5 h-1.5 bg-blue-400 rounded-full flex-shrink-0 mt-1.5" />{' '}
                  <span className="flex-1 leading-relaxed">
                    {safeRender(ing)}
                  </span>
                </li>
              ))}
          </ul>
        )}
        <h3 className="font-bold text-slate-200 mb-3 flex items-center gap-2 text-lg border-b border-slate-700 pb-2 mt-6">
          <ChefHat size={20} className="text-blue-500" /> Preparare
        </h3>
        {isEditing ? (
          <textarea
            value={
              Array.isArray(edited.instructions)
                ? edited.instructions.join('\n')
                : ''
            }
            onChange={(e) =>
              handleListChange('instructions', e.target.value)
            }
            className="w-full h-40 p-3 text-sm border rounded-xl dark:bg-slate-700 dark:text-white dark:border-slate-600 focus:ring-2 focus:ring-blue-500"
          />
        ) : (
          <div className="space-y-4 text-sm text-slate-300">
            {Array.isArray(recipe.instructions) &&
              recipe.instructions.map((step, i) => (
                <div key={i} className="flex gap-4">
                  <span className="font-bold text-blue-400 bg-blue-900/30 w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 text-xs border border-blue-800">
                    {i + 1}
                  </span>
                  <p className="flex-1 leading-relaxed">
                    {safeRender(step)}
                  </p>
                </div>
              ))}
          </div>
        )}
        <button
          onClick={onBack}
          className="w-full mt-10 py-3.5 bg-slate-700 hover:bg-slate-600 text-slate-200 font-bold rounded-xl transition-colors"
        >
          Înapoi
        </button>
      </div>
    </div>
  );
};

// TAB: COOKBOOK
const CookbookTab = ({
  category,
  setCategory,
  recipes,
  onSelect,
  allRecipes,
  title,
  isCommunity
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const categories = COOKBOOK_CATEGORIES;

  const counts = useMemo(() => {
    if (isCommunity) return {};
    const res = { Toate: (allRecipes || []).length };
    categories.forEach((c) => {
      if (c.id !== 'Toate') res[c.id] = 0;
    });
    (allRecipes || []).forEach((r) => {
      if (res[r.category] !== undefined) res[r.category]++;
    });
    return res;
  }, [allRecipes, isCommunity, categories]);

  const displayedRecipes = useMemo(() => {
    let result = [...recipes];
    if (isCommunity && searchTerm) {
      const lower = removeDiacritics(searchTerm);
      result = result.filter((r) =>
        removeDiacritics(r.title || '').includes(lower)
      );
    }
    result.sort((a, b) => (b.votes || 0) - (a.votes || 0));
    return result;
  }, [recipes, searchTerm, isCommunity]);

  const paginatedRecipes = useMemo(() => {
    if (!isCommunity) return displayedRecipes;
    const start = (currentPage - 1) * itemsPerPage;
    return displayedRecipes.slice(start, start + itemsPerPage);
  }, [displayedRecipes, currentPage, isCommunity]);

  const totalPages = Math.ceil(displayedRecipes.length / itemsPerPage);

  return (
    <div className="space-y-4 animate-fade-in">
      {title && (
        <h2 className="text-lg font-bold text-center text-slate-200 mb-2">
          {title}
        </h2>
      )}

      {isCommunity && (
        <div className="relative max-w-md mx-auto mb-6">
          <Search
            className="absolute left-3 top-2.5 text-slate-400"
            size={18}
          />
          <input
            type="text"
            placeholder="Caută o rețetă în comunitate..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-700 bg-slate-800 focus:ring-2 focus:ring-green-500 outline-none transition shadow-sm text-sm text-white"
          />
        </div>
      )}

      {!isCommunity && (
        <div className="flex flex-wrap gap-2 justify-center">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => setCategory(c.id)}
              className={`px-3 py-1.5 rounded-xl text-xs font-bold border transition flex items-center gap-1.5 ${
                category === c.id
                  ? 'bg-blue-600 text-white border-blue-600 shadow-md'
                  : 'bg-slate-800 text-slate-300 border-slate-700 hover:bg-slate-700'
              }`}
            >
              {c.icon} {c.id}{' '}
              <span
                className={`ml-1 px-1.5 rounded-md text-[10px] ${
                  category === c.id
                    ? 'bg-blue-500 text-blue-100'
                    : 'bg-slate-700 text-slate-400'
                }`}
              >
                {counts[c.id] || 0}
              </span>
            </button>
          ))}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {(isCommunity ? paginatedRecipes : displayedRecipes).map((r) => (
          <div
            key={r.id}
            onClick={() => onSelect(r)}
            className={`bg-slate-800 p-4 rounded-2xl border border-slate-700 shadow-sm cursor-pointer relative overflow-hidden transition hover:shadow-md ${
              r.hasAllIngredients
                ? 'ring-2 ring-green-400 ring-offset-2 dark:ring-offset-slate-900'
                : ''
            }`}
          >
            {r.hasAllIngredients && (
              <div className="absolute top-0 right-0 bg-green-500 text-white text-[10px] px-2 py-1 rounded-bl-lg font-bold shadow-sm z-10">
                Poți găti asta!
              </div>
            )}

            <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-yellow-900/30 text-yellow-400 px-2 py-1 rounded-lg text-xs font-bold">
              <Star
                size={12}
                className="fill-yellow-500 text-yellow-500"
              />{' '}
              {r.votes || 0}
            </div>

            <div className="flex gap-3">
              <div className="text-4xl bg-slate-700 w-16 h-16 rounded-xl flex items-center justify-center shadow-inner">
                {safeRender(r.image)}
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-white leading-tight">
                  {safeRender(r.title)}
                </h3>
                {(r.authorName || (isCommunity && r.publishedAt)) && (
                  <div className="text-[10px] text-slate-400 mt-0.5 flex items-center gap-1 flex-wrap">
                    {r.authorName && (
                      <>
                        <User size={8} /> {safeRender(r.authorName)}
                      </>
                    )}
                    {r.publishedAt && (
                      <span className="opacity-75">
                        • {formatDateTime(r.publishedAt)}
                      </span>
                    )}
                  </div>
                )}
                <div className="flex flex-wrap gap-2 mt-2 text-xs text-slate-400">
                  <span className="flex items-center gap-1 bg-slate-700 px-1.5 rounded border border-slate-600">
                    <Activity size={10} /> {safeRender(r.time)}
                  </span>
                  {r.carbs && (
                    <span className="bg-green-900/30 text-green-400 px-1.5 rounded border border-green-800 font-bold">
                      {safeRender(r.carbs)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {(isCommunity ? paginatedRecipes : displayedRecipes).length === 0 && (
          <div className="text-center text-xs text-slate-400 col-span-full py-10 border border-dashed border-slate-700 rounded-2xl">
            Nicio rețetă găsită.
          </div>
        )}
      </div>

      {isCommunity && totalPages > 1 && (
        <div className="flex justify-center items-center gap-4 mt-6">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            className="p-2 rounded-full bg-slate-800 border border-slate-700 disabled:opacity-50 hover:bg-slate-700 transition"
          >
            <ChevronLeft size={20} />
          </button>
          <span className="text-sm font-bold text-slate-300">
            Pagina {currentPage} din {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            className="p-2 rounded-full bg-slate-800 border border-slate-700 disabled:opacity-50 hover:bg-slate-700 transition"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      )}
    </div>
  );
};

// TAB: SALVATE
const SavedRecipesTab = ({
  savedRecipes,
  onSelectRecipe,
  onDeleteRecipe
}) => {
  return (
    <div className="space-y-4 animate-fade-in">
      <div className="text-center mb-6">
        <h2 className="text-lg font-bold text-white flex items-center justify-center gap-2">
          <Heart className="text-red-500 fill-red-500" size={20} /> Rețetele
          Mele Salvate
        </h2>
        <p className="text-xs text-slate-400">
          Rețete generate de AI pe care le-ai păstrat.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {(savedRecipes || []).map((recipe) => (
          <div
            key={recipe.id}
            onClick={() => onSelectRecipe(recipe)}
            className="bg-slate-800 p-4 rounded-2xl border border-indigo-900/50 shadow-sm cursor-pointer relative overflow-hidden transition hover:shadow-md group"
          >
            <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteRecipe(recipe.id);
                }}
                className="p-1.5 bg-slate-700 rounded-full text-red-500 shadow hover:bg-red-900/30"
              >
                <Trash2 size={14} />
              </button>
            </div>
            <div className="flex gap-3">
              <div className="text-4xl bg-indigo-900/30 w-16 h-16 rounded-xl flex items-center justify-center shadow-inner">
                {safeRender(recipe.image)}
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-white leading-tight">
                  {safeRender(recipe.title)}
                </h3>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-[10px] font-bold bg-indigo-900 text-indigo-300 px-1.5 py-0.5 rounded flex items-center gap-1">
                    <Sparkles size={8} /> AI
                  </span>
                </div>
                <div className="flex flex-wrap gap-2 mt-2 text-xs text-slate-400">
                  <span className="flex items-center gap-1 bg-slate-700 px-1.5 rounded border border-slate-600">
                    <Activity size={10} /> {safeRender(recipe.time)}
                  </span>
                  <span className="bg-green-900/30 text-green-400 px-1.5 rounded border border-green-800 font-bold">
                    {safeRender(recipe.carbs || 'Low')} carbs
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
        {(savedRecipes || []).length === 0 && (
          <div className="text-center text-xs text-slate-400 col-span-full py-16 bg-slate-800 rounded-2xl border border-dashed border-slate-700 flex flex-col items-center gap-3">
            <Heart
              size={32}
              className="text-slate-600"
            />
            <p>Nu ai salvat nicio rețetă încă.</p>
          </div>
        )}
      </div>
    </div>
  );
};

// --- 8. APLICATIA PRINCIPALA ---
export default function App() {
  const [user, setUser] = useState(null);
  const [myIngredients, setMyIngredients] = useState([]);
  const [savedRecipes, setSavedRecipes] = useState([]);
  const [cloudRecipes, setCloudRecipes] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Altele');
  const [activeTab, setActiveTab] = useState('pantry');
  
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [darkMode] = useState(true);
  const [cookbookCategory, setCookbookCategory] = useState('Toate');
  const [showPrint, setShowPrint] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [aiExtraInstructions, setAiExtraInstructions] = useState('');
  const [aiServings, setAiServings] = useState(2);
  const [isSaving, setIsSaving] = useState(false);

  const isAdmin =
    user &&
    !user.isAnonymous &&
    ADMIN_EMAILS.includes(user.email || '');

  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  useEffect(() => {
    if (selectedRecipe && activeTab === 'details') {
      const updatedLocal = savedRecipes.find(r => r.id === selectedRecipe.id);
      if (updatedLocal) {
        if (updatedLocal.communityId !== selectedRecipe.communityId ||
            updatedLocal.shareId !== selectedRecipe.shareId) {
           setSelectedRecipe(prev => ({ ...prev, communityId: updatedLocal.communityId, shareId: updatedLocal.shareId }));
        }
      }
    }
  }, [savedRecipes, selectedRecipe, activeTab]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const recipeIdFromUrl = params.get('reteta');

    if (recipeIdFromUrl) {
      const findAndOpenRecipe = async () => {
        let found = RECIPES_DB.find((r) => r.id === recipeIdFromUrl);
        if (!found && db) {
          try {
            const docRef = doc(db, 'recipes', recipeIdFromUrl);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              found = { id: docSnap.id, ...docSnap.data() };
            } else {
              const q = query(
                collection(db, 'recipes'),
                where('shareId', '==', recipeIdFromUrl)
              );
              const snap = await getDocs(q);
              if (!snap.empty) {
                const docSnap2 = snap.docs[0];
                found = { id: docSnap2.id, ...docSnap2.data() };
              }
            }
          } catch (e) {
            console.error('Eroare deep link:', e);
          }
        }
        if (found) {
          setSelectedRecipe(found);
          setActiveTab('details');
        } else {
          safeUpdateURL(window.location.pathname);
        }
      };
      findAndOpenRecipe();
    } else {
      const savedTab = localStorage.getItem('activeTab');
      if (savedTab) setActiveTab(savedTab);
    }
  }, []);

  useEffect(() => {
    if (activeTab !== 'details') {
      try {
        localStorage.setItem('activeTab', activeTab);
      } catch (e) {}
    }
  }, [activeTab]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
      } else {
        signInAnonymously(auth).catch((error) =>
          console.error(error)
        );
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!db) return;
    const q = query(collection(db, 'recipes'));
    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data()
        }));
        setCloudRecipes(items);
      },
      (error) => console.error(error)
    );
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!user) {
      setMyIngredients([]);
      setSavedRecipes([]);
      return;
    }
    const pantryQuery = query(
      collection(db, 'users', user.uid, 'pantryItems')
    );
    const savedQuery = query(
      collection(db, 'users', user.uid, 'savedRecipes')
    );
    const unsubPantry = onSnapshot(pantryQuery, (s) =>
      setMyIngredients(
        s.docs
          .map((d) => d.data())
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    const unsubSaved = onSnapshot(savedQuery, (s) =>
      setSavedRecipes(
        s.docs
          .map((d) => d.data())
          .sort((a, b) => (b.id || '').localeCompare(a.id || ''))
      )
    );
    return () => {
      unsubPantry();
      unsubSaved();
    };
  }, [user]);

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (e) {
      alert(e.message);
    }
  };
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (e) {
      console.error(e);
    }
  };

  const handleVote = async (recipe) => {
    if (!user) return;
    const recipeRef = doc(db, 'recipes', recipe.id);
    const hasVoted =
      recipe.votedBy && recipe.votedBy.includes(user.uid);
    try {
      if (hasVoted) {
        await updateDoc(recipeRef, {
          votes: (recipe.votes || 0) - 1,
          votedBy: arrayRemove(user.uid)
        });
      } else {
        await updateDoc(recipeRef, {
          votes: (recipe.votes || 0) + 1,
          votedBy: arrayUnion(user.uid)
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const publishRecipe = async (recipe) => {
    if (!user) return;
    
    const communityId = recipe.communityId;
    const isUpdate = !!communityId;

    const timestampNow = Date.now();
    const shareId = recipe.shareId || `comm-${timestampNow}`;
    const publicId = isUpdate ? communityId : `comm-${user.uid}-${timestampNow}`;
    const publicRef = doc(db, 'recipes', publicId);

    try {
      const recipeData = {
        ...recipe,
        id: publicId,
        shareId,
        type: 'community',
        authorName: user.displayName || 'Anonim',
        publishedAt: serverTimestamp(),
        ...(isUpdate ? {} : { votes: 0, votedBy: [] })
      };
      
      delete recipeData.communityId; 
      if (isUpdate) {
         delete recipeData.votes;
         delete recipeData.votedBy;
      }

      if (isUpdate) {
         await setDoc(publicRef, recipeData, { merge: true });
         setSelectedRecipe(prev => prev ? { ...prev, shareId } : prev);
         alert('Rețeta publică a fost actualizată! 🔄');
      } else {
         await setDoc(publicRef, recipeData);
         const privateRef = doc(db, 'users', user.uid, 'savedRecipes', recipe.id);
         await updateDoc(privateRef, { communityId: publicId, shareId });
         setSelectedRecipe(prev => prev ? { ...prev, communityId: publicId, shareId } : prev);
         
         alert('Rețeta a fost publicată cu succes în Comunitate! 🌍');
         setActiveTab('community');
      }
    } catch (e) {
      alert('Eroare: ' + e.message);
    }
  };

  const adminDeleteRecipeFromCloud = async (recipe) => {
    if (!isAdmin || !recipe?.id) return;

    const confirmDelete = window.confirm(
      `Sigur vrei să ȘTERGI DEFINITIV rețeta:\n\n"${recipe.title}"\n\nDin colecția globală "recipes"?`
    );
    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, 'recipes', recipe.id));
      alert('Rețeta a fost ștearsă din Firestore ✅');
    } catch (e) {
      console.error('Eroare ștergere admin:', e);
      alert('Nu am putut șterge rețeta: ' + e.message);
    }
  };

  const addIngredient = useCallback(async () => {
    const t = inputValue.trim();
    if (!t || !user) return;
    const c = removeDiacritics(t);
    if (
      myIngredients.some(
        (i) => removeDiacritics(i.name) === c
      )
    ) {
      setInputValue('');
      return;
    }
    let cat = selectedCategory;
    if (cat === 'Altele') cat = getCategoryForIngredient(t);
    const finalCat = CATEGORY_STYLES[cat] ? cat : 'Altele';
    await setDoc(
      doc(db, 'users', user.uid, 'pantryItems', c),
      { name: t, category: finalCat, isSelected: true }
    );
    setInputValue('');
    setSelectedCategory('Altele');
  }, [inputValue, selectedCategory, user, myIngredients]);

  const removeIngredient = async (n) => {
    if (user)
      await deleteDoc(
        doc(
          db,
          'users',
          user.uid,
          'pantryItems',
          removeDiacritics(n)
        )
      );
  };
  const toggleIngredient = async (n) => {
    if (!user) return;
    const c = removeDiacritics(n);
    const i = myIngredients.find(
      (x) => removeDiacritics(x.name) === c
    );
    if (i)
      await updateDoc(
        doc(db, 'users', user.uid, 'pantryItems', c),
        { isSelected: !i.isSelected }
      );
  };

  const saveRecipe = async (r) => {
    if (!user) return;
    setIsSaving(true);
    await setDoc(
      doc(db, 'users', user.uid, 'savedRecipes', r.id),
      JSON.parse(JSON.stringify({ ...r, userId: user.uid }))
    );
    setIsSaving(false);
  };
  const updateRecipe = async (u) => {
    setSelectedRecipe(u);
    if (savedRecipes.some((r) => r.id === u.id))
      await saveRecipe(u);
  };

  const deleteRecipe = async (id) => {
    if (
      user &&
      savedRecipes.some((r) => r.id === id)
    )
      await deleteDoc(
        doc(db, 'users', user.uid, 'savedRecipes', id)
      );
    if (selectedRecipe?.id === id) handleBack();
  };

  const handleSelectRecipe = (r) => {
    setSelectedRecipe(r);
    setActiveTab('details');
    const shareKey = r.shareId || r.id;
    const newUrl = `${window.location.pathname}?reteta=${shareKey}`;
    safeUpdateURL(newUrl);
  };

  const handleBack = () => {
    safeUpdateURL(window.location.pathname);
    if (selectedRecipe?.isAiGenerated) {
      if (selectedRecipe.type === 'community')
        setActiveTab('community');
      else setActiveTab('pantry');
    } else if (
      savedRecipes.some(
        (r) => r.id === selectedRecipe?.id
      )
    ) {
      setActiveTab('saved');
    } else {
      setActiveTab('cookbook');
    }
    setSelectedRecipe(null);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    const d = getCategoryForIngredient(e.target.value);
    if (d !== 'Altele') setSelectedCategory(d);
  };

  const activeIngredients = useMemo(
    () => myIngredients.filter((i) => i.isSelected),
    [myIngredients]
  );
  const groupedIngredients = useMemo(() => {
    const g = Object.keys(INGREDIENT_CATEGORIES).reduce(
      (a, c) => {
        a[c] = [];
        return a;
      },
      { Altele: [] }
    );
    myIngredients.forEach((i) => {
      if (g[i.category]) g[i.category].push(i);
      else g.Altele.push(i);
    });
    return g;
  }, [myIngredients]);
  const allRecipes = useMemo(
    () => (cloudRecipes.length > 0 ? cloudRecipes : RECIPES_DB),
    [cloudRecipes]
  );
  const officialRecipes = useMemo(
    () => allRecipes.filter((r) => r.type !== 'community'),
    [allRecipes]
  );
  const communityRecipes = useMemo(
    () => allRecipes.filter((r) => r.type === 'community'),
    [allRecipes]
  );

  const cookbookRecipes = useMemo(() => {
    let source =
      activeTab === 'community'
        ? communityRecipes
        : officialRecipes;
    let r = source;
    if (activeTab !== 'community' && cookbookCategory !== 'Toate') {
      r = r.filter((x) => x.category === cookbookCategory);
    }
    return r.map((x) => {
      const ingredients = Array.isArray(x.ingredients)
        ? x.ingredients
        : [];
      const matchCount = ingredients.filter((ri) =>
        myIngredients.some((mi) =>
          removeDiacritics(mi.name).includes(
            removeDiacritics(ri)
          )
        )
      ).length;
      return {
        ...x,
        hasAllIngredients:
          ingredients.length > 0 &&
          matchCount >= ingredients.length * 0.6
      };
    });
  }, [
    cookbookCategory,
    myIngredients,
    officialRecipes,
    communityRecipes,
    activeTab
  ]);

  const generateAiRecipe = async (overrideIngredients = null) => {
    const ings =
      overrideIngredients ||
      activeIngredients.map((i) => i.name);
    if (ings.length === 0) {
      setAiError('Selectează ingrediente!');
      return;
    }
    setIsGenerating(true);
    setAiError(null);
    const list = ings.join(', ');
    const instr = aiExtraInstructions
      ? `Preferințe: "${aiExtraInstructions}".`
      : '';
    const prompt = `Creează o rețetă românească, sănătoasă și low-carb pentru ${aiServings} porții folosind: ${list}. ${instr} Returnează STRICT JSON: {"title": "string", "category": "Prânz", "time": "20 min", "calories": "300 kcal", "carbs": "10g", "servings": ${aiServings}, "image": "emoji", "isDiabeticFriendly": true, "ingredients": ["list strings with quantities"], "instructions": ["list strings"]}`;
    try {
      const res = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${apiKey}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            contents: [{ parts: [{ text: prompt }] }],
            generationConfig: { responseMimeType: 'application/json' }
          })
        }
      );
      if (!res.ok) throw new Error('API Error');
      const data = await res.json();
      const text =
        data?.candidates?.[0]?.content?.parts?.[0]?.text;
      handleSelectRecipe({
        ...JSON.parse(text),
        id: 'ai-' + Date.now(),
        isAiGenerated: true
      });
    } catch (e) {
      setAiError('Eroare AI.');
      console.error(e);
    } finally {
      setIsGenerating(false);
    }
  };

  const randomAi = () => {
    if (myIngredients.length === 0) {
      setAiError('Cămara e goală!');
      return;
    }
    const shuffled = [...myIngredients].sort(
      () => 0.5 - Math.random()
    );
    generateAiRecipe(
      shuffled.slice(0, 3).map((i) => i.name)
    );
  };

  return (
    <div
      className={`min-h-screen font-sans flex flex-col pb-20 md:pb-0 transition-colors duration-300 ${
        darkMode
          ? 'bg-slate-900 text-slate-100'
          : 'bg-slate-50 text-slate-800'
      }`}
    >
      {showPrint && selectedRecipe && (
        <PrintPreviewScreen
          recipe={selectedRecipe}
          onClose={() => setShowPrint(false)}
        />
      )}

      <div className={showPrint ? 'hidden' : 'block'}>
        <div className="bg-gradient-to-r from-blue-700 to-blue-600 dark:from-slate-800 dark:to-slate-900 text-white p-4 shadow-lg sticky top-0 z-50">
          <div className="max-w-4xl mx-auto flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold">
                <AppLogo />
              </h1>
              <div className="flex items-center gap-2 text-xs text-blue-200">
                {user?.isAnonymous
                  ? 'Vizitator (Anonim)'
                  : user?.displayName || 'Utilizator'}
                {isAdmin && (
                  <span className="px-2 py-0.5 rounded-full bg-yellow-300 text-yellow-900 text-[10px] font-bold">
                    ADMIN
                  </span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={
                  user?.isAnonymous
                    ? handleGoogleLogin
                    : handleLogout
                }
                className={`px-3 py-2 rounded-full transition flex items-center gap-2 text-sm font-bold shadow-sm ${
                  user?.isAnonymous
                    ? 'bg-white text-blue-700 hover:bg-slate-100'
                    : 'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                {user?.isAnonymous ? (
                  <>
                    <LogIn size={16} />{' '}
                    <span className="hidden sm:inline">
                      Conectare Google
                    </span>
                  </>
                ) : (
                  <>
                    <LogOut size={16} />{' '}
                    <span className="hidden sm:inline">
                      Deconectare
                    </span>
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="max-w-4xl mx-auto mt-4 flex gap-3 overflow-x-auto pb-1 custom-scrollbar">
            <button
              onClick={() => {
                setActiveTab('pantry');
                safeUpdateURL(window.location.pathname);
              }}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition flex items-center gap-2 ${
                activeTab === 'pantry'
                  ? 'bg-white text-blue-700 dark:bg-slate-700 dark:text-white shadow-md'
                  : 'bg-blue-800/40'
              }`}
            >
              <ShoppingBasket size={16} /> Cămara
            </button>
            <button
              onClick={() => {
                setActiveTab('cookbook');
                safeUpdateURL(window.location.pathname);
              }}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition flex items-center gap-2 ${
                activeTab === 'cookbook'
                  ? 'bg-white text-blue-700 dark:bg-slate-700 dark:text-white shadow-md'
                  : 'bg-blue-800/40'
              }`}
            >
              <BookOpen size={16} /> Meniu Rețete
            </button>
            <button
              onClick={() => {
                setActiveTab('community');
                safeUpdateURL(window.location.pathname);
              }}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition flex items-center gap-2 ${
                activeTab === 'community'
                  ? 'bg-white text-green-700 dark:bg-green-700 dark:text-white shadow-md'
                  : 'bg-green-800/40'
              }`}
            >
              <Globe size={16} /> Comunitate
            </button>
            <button
              onClick={() => {
                setActiveTab('saved');
                safeUpdateURL(window.location.pathname);
              }}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition flex items-center gap-2 ${
                activeTab === 'saved'
                  ? 'bg-white text-indigo-700 dark:bg-indigo-900 dark:text-indigo-200 shadow-md'
                  : 'bg-indigo-800/40'
              }`}
            >
              <Heart size={16} /> Salvate
            </button>

            {isAdmin && (
              <button
                onClick={() => {
                  setActiveTab('admin');
                  safeUpdateURL(window.location.pathname);
                }}
                className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition flex items-center gap-2 ${
                  activeTab === 'admin'
                    ? 'bg-white text-amber-700 dark:bg-amber-900 dark:text-amber-100 shadow-md'
                    : 'bg-amber-800/40'
                }`}
              >
                <Shield size={16} /> Admin
              </button>
            )}
          </div>
        </div>

        <main className="max-w-4xl mx-auto p-4 w-full flex-1">
          {activeTab === 'pantry' && (
            <PantryTab
              groupedIngredients={groupedIngredients}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              inputValue={inputValue}
              setInputValue={setInputValue}
              onInputChange={handleInputChange}
              onAdd={addIngredient}
              onToggle={toggleIngredient}
              onDelete={removeIngredient}
              activeIngredients={activeIngredients}
              onGenerateAi={generateAiRecipe}
              isGenerating={isGenerating}
              aiError={aiError}
              extraInst={aiExtraInstructions}
              setExtraInst={setAiExtraInstructions}
              servings={aiServings}
              setServings={setAiServings}
              onRandomAi={randomAi}
              isAnonymous={user?.isAnonymous}
              handleLogin={handleGoogleLogin}
            />
          )}
          {activeTab === 'cookbook' && (
            <CookbookTab
              category={cookbookCategory}
              setCategory={setCookbookCategory}
              recipes={cookbookRecipes}
              onSelect={handleSelectRecipe}
              allRecipes={officialRecipes}
              title="Meniu Oficial"
              isCommunity={false}
            />
          )}
          {activeTab === 'community' && (
            <CookbookTab
              category={cookbookCategory}
              setCategory={setCookbookCategory}
              recipes={cookbookRecipes}
              onSelect={handleSelectRecipe}
              allRecipes={communityRecipes}
              title="Comunitatea NutrițieSmart 🌍"
              isCommunity={true}
            />
          )}
          {activeTab === 'saved' && (
            <SavedRecipesTab
              savedRecipes={savedRecipes}
              onSelectRecipe={handleSelectRecipe}
              onDeleteRecipe={deleteRecipe}
            />
          )}
          {activeTab === 'admin' && isAdmin && (
            <AdminPanel
              recipes={allRecipes}
              onAdminDelete={adminDeleteRecipeFromCloud}
            />
          )}
          {activeTab === 'details' && selectedRecipe && (
            <RecipeView
              recipe={selectedRecipe}
              onBack={handleBack}
              onSave={saveRecipe}
              onUpdate={updateRecipe}
              onDelete={deleteRecipe}
              isSaved={savedRecipes.some(
                (r) => r.id === selectedRecipe.id
              )}
              isSaving={isSaving}
              onPrint={() => setShowPrint(true)}
              onVote={handleVote}
              user={user}
              onPublish={publishRecipe}
              isPublished={cloudRecipes.some(
                (cr) =>
                  cr.type === 'community' &&
                  cr.title === selectedRecipe.title &&
                  cr.authorName ===
                    (user?.displayName || 'Anonim')
              )}
            />
          )}
        </main>
      </div>
      <style>{`
        .custom-scrollbar::-webkit-scrollbar { height: 4px; width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #475569; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
      `}</style>
    </div>
  );
}
